import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import './App.css';

import HeaderStrip from './components/header-footer/header-strip.component';
import HomePage from './pages/home-page';
import BiographyPage from './pages/biography-page';
import VideoPage from './pages/video-page';
import PhotoPage from './pages/photo-page';
import SupportPage from './pages/support-page';
import SaturdayConcertsPage from './pages/saturday-concerts-page';
import FooterStrip from './components/header-footer/footer-strip.component';
import ContactPage from './pages/contact.page';
import RadioPage from './pages/radio-page';
import EventsPage from './pages/events-page';

function App() {
  return (
    <Router>
      <HeaderStrip />
      <div className="App">
        {/* <div className="Arrow bounce">
          <svg id="more-arrows">
            <polygon className="arrow-top" points="37.6,27.9 1.8,1.3 3.3,0 37.6,25.3 71.9,0 73.7,1.3 "/>
            <polygon className="arrow-middle" points="37.6,45.8 0.8,18.7 4.4,16.4 37.6,41.2 71.2,16.4 74.5,18.7 "/>
            <polygon className="arrow-bottom" points="37.6,64 0,36.1 5.1,32.8 37.6,56.8 70.4,32.8 75.5,36.1 "/>
          </svg>
        </div> */}

        <Routes>
          <Route path="/events" element={<EventsPage />} />
          <Route path="/saturday" element={<SaturdayConcertsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/photos" element={<PhotoPage />} />
          <Route path="/videos" element={<VideoPage />} />
          <Route path="/bio" element={<BiographyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/radio" element={<RadioPage />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
      <FooterStrip />
    </Router>
  );
}



export default App;
